import {
  formatGetHeaders, formatPostHeaders, formatPutHeaders
} from '@configurations/api-configuration';
import { SubscriptionGateway } from '@scenario/gateways/subscription.gateway';
import { environment } from '../../../../../environments/environment';
import { Subscription } from '@scenario/models/subscription.model';

export class ApiSubscriptionGateway implements SubscriptionGateway {
  private readonly subscriptionApi = `${environment.backend_url}/api/v1/user/subscription`;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async subscribeToNotification(subscription: { zoneId: number | null; sourceId: number |null }) {

    try {
      const response = await fetch(`${this.subscriptionApi}`, await formatPostHeaders(subscription));
      return await response.json();
    } catch (error) {
      throw new Error('Error subscribing to notifications' + error);
    }
  }

  async unsubscribeToNotification(subscriptionId: number ): Promise<boolean> {
    try {
      const response = await fetch(`${this.subscriptionApi}/disable?subscriptionId=${subscriptionId}`, await formatPutHeaders());
      return await response.json();
    } catch (error) {
      throw new Error('Error unsubscribing to notifications' + error);
    }
  }

  async retrieveAll(): Promise<Subscription[]> {
    try {
      const response = await fetch(`${this.subscriptionApi}`, await formatGetHeaders());
      return (await response.json()) as Subscription[];
    } catch (error) {
      throw new Error('Error retrieving notifications' + error);
    }
  }
}
